<ng-container *ngIf="appModeService.isApp(); else webFallback">
  <section class="app-profile-view">
    <header class="app-profile-header">
      <button type="button" class="icon-btn" (click)="goBack()">
        <i class="pi pi-arrow-left"></i>
      </button>
      <h1>{{ 'PROFILE.PERSONAL_INFO_TITLE' | translate }}</h1>
      <button type="button" class="edit-btn" (click)="toggleEditMode()">
        {{ isEditMode ? ('PROFILE.BTN_CANCEL' | translate) : ('PROFILE.BTN_EDIT' | translate) }}
      </button>
    </header>

    <section class="app-profile-content" *ngIf="!isEditMode; else editMode">
      <div class="profile-row">
        <div class="row-label">{{ 'PROFILE.LABEL_FULL_NAME' | translate }}</div>
        <div class="row-value">{{ name }}</div>
      </div>
      <div class="profile-row">
        <div class="row-label">{{ 'PROFILE.LABEL_EMAIL' | translate }}</div>
        <div class="row-value">{{ email }}</div>
      </div>
      <div class="profile-row">
        <div class="row-label">{{ 'PROFILE.LABEL_PHONE' | translate }}</div>
        <div class="row-value" [class.not-set]="!phone">
          {{ phone || ('PROFILE.PHONE_NOT_SET' | translate) }}
        </div>
      </div>
    </section>

    <ng-template #editMode>
      <section class="app-profile-content">
        <div class="field-group">
          <label>{{ 'PROFILE.LABEL_FULL_NAME' | translate }}</label>
          <input type="text" [(ngModel)]="name" />
        </div>

        <div class="field-group">
          <label>{{ 'PROFILE.LABEL_EMAIL' | translate }}</label>
          <input type="email" [value]="email" disabled />
          <small>{{ 'PROFILE.EMAIL_READONLY_NOTE' | translate }}</small>
        </div>

        <div class="field-group">
          <label>{{ 'PROFILE.LABEL_PHONE' | translate }}</label>
          <input type="text" [(ngModel)]="phone" />
        </div>

        <div class="error-message" *ngIf="errorMessage">{{ errorMessage | translate }}</div>

        <button type="button" class="save-btn" [disabled]="isSaving" (click)="onSave()">
          {{ 'PROFILE.BTN_SAVE' | translate }}
        </button>

        <button type="button" class="cancel-btn" (click)="toggleEditMode()">
          {{ 'PROFILE.BTN_CANCEL' | translate }}
        </button>
      </section>
    </ng-template>
  </section>
</ng-container>

<ng-template #webFallback>
  <div class="unsupported-view">This page is available in app mode only.</div>
</ng-template>
